import { render, staticRenderFns } from "./w-search.vue?vue&type=template&id=4eec5bf7&lang=pug&"
import script from "./w-search.vue?vue&type=script&lang=js&"
export * from "./w-search.vue?vue&type=script&lang=js&"
import style0 from "./w-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eec5bf7')) {
      api.createRecord('4eec5bf7', component.options)
    } else {
      api.reload('4eec5bf7', component.options)
    }
    module.hot.accept("./w-search.vue?vue&type=template&id=4eec5bf7&lang=pug&", function () {
      api.rerender('4eec5bf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-search.vue"
export default component.exports